import { Controller } from "@hotwired/stimulus"

// Disables the submit button and changes its label while the form is being submitted.
// On turbo:submit-end with error, restores the button so the user can retry.
export default class extends Controller {
  static values = { label: String }

  submit(event) {
    const btn = this.#submitButton()
    if (!btn) return

    this._originalLabel = btn.innerHTML
    btn.disabled = true
    btn.innerHTML = this.labelValue || "Aguarde..."

    // Para forms com data-turbo="false" (ex: download de arquivo),
    // restaura o botão quando a janela recupera o foco após o download
    if (this.element.dataset.turbo === "false") {
      window.addEventListener("focus", () => this.#restore(), { once: true })
    }
  }

  submitEnd(event) {
    if (event.detail?.success) return
    this.#restore()
  }

  #submitButton() {
    return this.element.querySelector('[type="submit"]')
  }

  #restore() {
    const btn = this.#submitButton()
    if (!btn || !this._originalLabel) return
    btn.disabled = false
    btn.innerHTML = this._originalLabel
  }
}
